import { useContext, useEffect } from "react";
import { IGlobalLayoutProps } from "./GlobalLayout.interface";
import { AuthenticationContext } from "../../shared/providers/authentication/authentication.provider";
import { LoadingContext } from "../../shared/providers/loading/loading.provider";
import Loading from "../Loading/Loading";
import Navbar from "../Navbar/Navbar";
import Header from "../Header/Header";
import { APP_CONFIGS } from "../../shared/constants";
import { DatContext } from "../../shared/providers/dat/dat.provider";
import { Outlet } from "react-router-dom";
import { LayoutContext } from "../../shared/providers/layout/layout.provider";

function GlobalLayout({ children }: IGlobalLayoutProps) {
    const { isAuthenticated } = useContext(AuthenticationContext);
    const { hasLoading } = useContext(LoadingContext);
    const { header, navbar, main } = useContext(LayoutContext);
    // const { dats } = useContext(DatContext);

    useEffect(() => {
        document.title = APP_CONFIGS.title;
    }, []);

    return (
        <>
            {hasLoading && <Loading />}
            {isAuthenticated && (
                <div className="layout">
                    {/* {dats.map(d => <DatPopup key={d.id} dat={d}/>)} */}
                    <Navbar layoutRef={navbar} />
                    <Header layoutRef={header} />
                    <main ref={main} className="content d-flex flex-column">
                        <Outlet />
                    </main>
                </div>
            )}
            {!isAuthenticated && (
                <>
                    <Outlet />
                </>
            )}
        </>
    );
}

export default GlobalLayout;
